/* Sends a copy of each enquiry to the CPFS enquiry log, which appends it to the
   tracking Google Sheet. Shopify keeps no record of contact form submissions and
   offers no webhook for them, so the copy has to be taken here, in the browser,
   at the moment the visitor submits.

   The one rule this file exists to honour: it NEVER calls preventDefault and
   never waits for a reply. The real submission goes to Shopify untouched and at
   full speed. The copy is handed to navigator.sendBeacon, which queues it at the
   browser level and delivers it independently, surviving the navigation that
   Shopify's own POST triggers. Nothing here can delay, block or duplicate an
   enquiry — the worst case is a missing spreadsheet row.

   Wired by a hidden <input name="cpfs_log"> inside each form. That name has no
   contact[] prefix, so Shopify never emails it, exactly like the honeypot. */
(function () {
  'use strict';

  var ENDPOINT = 'https://cpfs-enquiry-sync.savage-adfox-inc-domains.workers.dev';
  var STORE_KEY = 'cpfs-enquiry-ref';
  /* A confirmation older than this is not from the submission we just made. */
  var CONFIRM_WINDOW_MS = 30 * 60 * 1000;

  function send(path, payload) {
    var body = JSON.stringify(payload);
    /* text/plain keeps this a simple cross-origin request. Anything else would
       need a CORS preflight, and sendBeacon cannot perform one. */
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(ENDPOINT + path, blob)) return;
      }
    } catch (e) {
      /* fall through to fetch */
    }
    try {
      fetch(ENDPOINT + path, {
        method: 'POST',
        body: body,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        keepalive: true,
        mode: 'no-cors',
      });
    } catch (e) {
      /* The enquiry is already on its way to Shopify. Losing the copy is the
         acceptable failure here, so there is deliberately nothing to do. */
    }
  }

  function reference() {
    try {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
      var bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);
      return Array.prototype.map
        .call(bytes, function (b) {
          return ('0' + b.toString(16)).slice(-2);
        })
        .join('');
    } catch (e) {
      return String(Date.now().toString(16)) + Math.random().toString(16).slice(2, 14);
    }
  }

  function wire(marker) {
    var form = marker.form;
    if (!form || form.getAttribute('data-cpfs-logged')) return;
    form.setAttribute('data-cpfs-logged', '1');

    var formType = marker.value === 'quote' ? 'quote' : 'contact';
    var ref = reference();
    var startedAt = 0;

    form.addEventListener(
      'focusin',
      function () {
        startedAt = Date.now();
      },
      { once: true },
    );

    form.addEventListener('submit', function () {
      var fields = {};
      try {
        new FormData(form).forEach(function (value, name) {
          /* Only the emailed fields and the honeypot. Everything else Shopify
             adds to the form is machinery and does not belong in the Sheet. */
          if (name.indexOf('contact[') === 0 || name === 'website') {
            fields[name] = typeof value === 'string' ? value : '';
          }
        });
      } catch (e) {
        return;
      }

      /* Kept so the page Shopify redirects to can confirm this same submission. */
      try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify({ ref: ref, at: Date.now() }));
      } catch (e) {
        /* Private browsing. The row still lands, it just stays at Submitted. */
      }

      send('/enquiry', {
        ref: ref,
        form_type: formType,
        elapsed_ms: startedAt ? Date.now() - startedAt : null,
        page_url: String(location.href).split('#')[0].split('?')[0],
        fields: fields,
      });
    });
  }

  /* Shopify redirects back with contact_posted=true once it has accepted the
     enquiry. That is the only signal available that the submission became an
     email, and it is what separates a Confirmed row from a Submitted one. */
  function confirmPosted() {
    var posted =
      String(location.search).indexOf('contact_posted=true') !== -1 ||
      !!document.querySelector('.v3-form__status.is-success');
    if (!posted) return;

    var raw = null;
    try {
      raw = sessionStorage.getItem(STORE_KEY);
      sessionStorage.removeItem(STORE_KEY);
    } catch (e) {
      return;
    }
    if (!raw) return;

    var saved = null;
    try {
      saved = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!saved || !saved.ref) return;
    if (Date.now() - (saved.at || 0) > CONFIRM_WINDOW_MS) return;

    send('/enquiry/confirm', { ref: saved.ref });
  }

  function init() {
    var markers = document.querySelectorAll('input[name="cpfs_log"]');
    for (var i = 0; i < markers.length; i += 1) wire(markers[i]);
    confirmPosted();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
